import React from 'react';

import {Icon} from '@mui/material';
import './styles';

interface ScrollToBottomButtonProps {
  onClick: () => void;
  visible?: boolean;
}

const ScrollToBottomButton: React.FC<ScrollToBottomButtonProps> = ({
  onClick,
  visible,
}) => {
  return (
    <button
      id="scroll-to-bottom-button"
      type="button"
      onClick={onClick}
      className={`scroll-to-bottom-btn  ${visible ? '' : 'hidden'}`}>
      <Icon className="scroll-to-bottom-btn__icon">arrow_downward</Icon>
    </button>
  );
};

export default React.memo(ScrollToBottomButton);
